// extracted by mini-css-extract-plugin
module.exports = {"propertyCell":"InviteVendor_propertyCell__17i64","input":"InviteVendor_input__3XJb4","adminSelect":"InviteVendor_adminSelect__3Y_xU"};